module.exports = __webpack_public_path__ + "img/moneda-black.d16a49d9.svg";